import { request } from "utils/api";
import { Club } from "api/clubs";

// stripe balance from GET /owner/connected-account/balance
export interface StripeBalance {
    available: {
        amountCents: number,
        sourceType: string,
    }[],
    pending: {
        amountCents: number,
        sourceType: string,
    }[],
}

// fetch balance (GET /owner/connected-account/balance)
export const getBalance = (data: {
    clubId: string,
}) => request<StripeBalance>({
    data,
    endpoint: "/owner/connected-account/balance",
    method: "get",
});

// get express dashboard link (GET /owner/dashboard-login-link)
export const getStripeDashboardLink = (data: {
    clubId: string,
}) => request<{ link: string }>({
    data,
    endpoint: "/owner/dashboard-login-link",
    method: "get",
});

// get connect link (GET /owner/connect-stripe)
export const getStripeConnectLink = (data: {
    clubId: string,
    redirectUri: string,
}) => request<{ link: string }>({
    data,
    endpoint: "/owner/connect-stripe",
    method: "get",
});

// confirm connected account (POST /owner/confirm-connected-account)
export const postConfirmConnectedAccount = (data: {
    code: string,
    state: string,
}) => request<{}>({
    data,
    endpoint: "/owner/confirm-connected-account",
    method: "post",
});

// unlink stripe account (GET /owner/connected-account)
export const deleteStripe = (data: {
    clubId: string,
}) => request<Club>({
    data,
    endpoint: "/owner/connected-account",
    method: "delete",
});
